export enum Shapes {
    CUBE = "cube",
    CYLINDER = "cylinder",
    TRIANGULAR = "triangular"
}
